export default __webpack_public_path__ + "static/media/ic_stat1.dd42fe06.svg";